<template>
  <div class="book">
    <div class="row mt-md-5">
      <div class="col-sm-12 col-md-6">
        <img src="/static/images/book/hoshizora.png" class="img-fluid" alt="おひさまキッチン パンタくんほしぞらでおよいだよ！表紙画像">
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="row book-body">
          <div class="col-12">
            <img src="/static/images/book/hoshizora-title.png" class="img-fluid" alt="おひさまキッチン パンタくんほしぞらでおよいだよ！">
          </div>
          <div class="col-12">
            <p class="book-description">
              おひさまキッチンのどうぶつさんたちは
              あまのがわでおよぐのがだいすき！
              みんなみずぎにきがえたら、いかだにのって、
              よぞらにむかってしゅっぱつです！
            </p>
          </div>
          <div class="col-12">
            <p class="book-price">
              定価 本体 1,300 円 + 税
            </p>
          </div>
          <div class="col-12">
            <p class="book-spec">
              発売日: 2018/11/21 Format: A4 判変型 Size: 210x210mm<br>
              Pages: 32 ページ (全ページフルカラー) Binding: ハードカバー<br>
              ISBN: 978-4-7562-5113-8 発売元: パイ インターナショナル
            </p>
          </div>
          <div class="col-12 d-flex justify-content-md-start justify-content-sm-center">
            <a href="https://pie.co.jp/book/i/5113/" target="_blank">
              <img src="/static/images/book/buy-pie.png" class="img-fluid" alt="PIE通販購入する">
            </a>
            <a href="https://www.amazon.co.jp/dp/4756251137/" target="_blank">
              <img src="/static/images/book/buy-amazon.png" class="img-fluid" alt="Amazonで買う">
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="sample row">
          <div class="col-md-12 text-left">
            <b-link @click="showSample('hoshizora','0');">
              中身を見る
            </b-link>
          </div>
          <div v-for="(image, index) in images.hoshizora" class="col-4">
            <img :src="`${image.src}`" slot="img" class="img-fluid" @click="showSample('hoshizora',index);" />
          </div>
        </div>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/book/line.png" class="img-fluid" alt="黄色の破線">
      </div>
      <div class="col-sm-12 col-md-6">
        <img src="/static/images/book/okaimono.png" class="img-fluid" alt="おひさまキッチン パンタくんのおかいもの 表紙画像">
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="row book-body">
          <div class="col-12">
            <img src="/static/images/book/okaimono-title.png" class="img-fluid" alt="おひさまキッチン パンタくんのおかいもの">
          </div>
          <div class="col-12">
            <p class="book-description">
              おひさまキッチンがはるのかおりにつつまれるころ、
              おひさまいちばがやってきます。
              おいしくてふしぎなおみせがいっぱい。
              パンタくんたちは、おもしろいタネをかいました。
            </p>
          </div>
          <div class="col-12">
            <p class="book-price">
              定価 本体 1,300 円 + 税
            </p>
          </div>
          <div class="col-12">
            <p class="book-spec">
              発売日: 2018/5/14 Format: A4 判変型 Size: 210x210mm<br>
              Pages: 32 ページ (全ページフルカラー) Binding: ハードカバー<br>
              ISBN: 978-4-7562-5056-8 発売元: パイ インターナショナル
            </p>
          </div>
          <div class="col-12 d-flex justify-content-md-start justify-content-sm-center">
            <a href="https://pie.co.jp/book/i/5056/" target="_blank">
              <img src="/static/images/book/buy-pie.png" class="img-fluid" alt="PIE通販購入する">
            </a>
            <a href="https://www.amazon.co.jp/dp/4756250564/" target="_blank">
              <img src="/static/images/book/buy-amazon.png" class="img-fluid" alt="Amazonで買う">
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="sample row">
          <div class="col-md-12 text-left">
            <b-link @click="showSample('okaimono','0');">
              中身を見る
            </b-link>
          </div>
          <div v-for="(image, index) in images.okaimono" class="col-4">
            <img :src="`${image.src}`" slot="img" class="img-fluid" @click="showSample('okaimono',index);" />
          </div>
        </div>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/book/line.png" class="img-fluid" alt="黄色の破線">
      </div>
      <div class="col-sm-12 col-md-6">
        <img src="/static/images/book/mori.png" class="img-fluid" alt="おひさまキッチン パンタくんプレゼントのもりへ 表紙画像">
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="row book-body">
          <div class="col-12">
            <img src="/static/images/book/mori-title.png" class="img-fluid" alt="おひさまキッチン パンタくんプレゼントのもりへ">
          </div>
          <div class="col-12">
            <p class="book-description">
              おひさまキッチンに、おさとうのゆきがふりはじめました。
              それはもうすぐ、クリスマスがやってくるあいずです。
              どうぶつさんたちは、どんなプレゼントを
              もらえるのでしょう？
            </p>
          </div>
          <div class="col-12">
            <p class="book-price">
              定価 本体 1,300 円 + 税
            </p>
          </div>
          <div class="col-12">
            <p class="book-spec">
              発売日: 2017/11/10 Format: A4 判変型 Size: 210x210mm<br>
              Pages: 32 ページ (全ページフルカラー) Binding: ハードカバー<br>
              ISBN: 978-4-7562-4967-8 発売元: パイ インターナショナル
            </p>
          </div>
          <div class="col-12 d-flex justify-content-md-start justify-content-sm-center">
            <a href="https://pie.co.jp/book/i/4967/" target="_blank">
              <img src="/static/images/book/buy-pie.png" class="img-fluid" alt="PIE通販購入する">
            </a>
            <a href="https://www.amazon.co.jp/dp/4756249671" target="_blank">
              <img src="/static/images/book/buy-amazon.png" class="img-fluid" alt="Amazonで買う">
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="sample row">
          <div class="col-md-12 text-left">
            <b-link @click="showSample('mori','0');">
              中身を見る
            </b-link>
          </div>
          <div v-for="(image, index) in images.mori" class="col-4">
            <img :src="`${image.src}`" slot="img" class="img-fluid" @click="showSample('mori',index);" />
          </div>
        </div>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/book/line.png" class="img-fluid" alt="黄色の破線">
      </div>
      <div class="col-sm-12 col-md-6">
        <img src="/static/images/book/isoide.png" class="img-fluid" alt="おひさまキッチン パンタくん いそいで！ 表紙画像">
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="row book-body">
          <div class="col-12">
            <img src="/static/images/book/isoide-title.png" class="img-fluid" alt="おひさまキッチン パンタくん いそいで！">
          </div>
          <div class="col-12">
            <p class="book-description">
              あさ、まだくらいうちから、パンダくんたちがおきて、
              なにかをしようとしています。とってもいそいでいるけど、
              さて、なんのじゅんびをしているのでしょう？
            </p>
          </div>
          <div class="col-12">
            <p class="book-price">
              定価 本体 1,300 円 + 税
            </p>
          </div>
          <div class="col-12">
            <p class="book-spec">
              発売日: 2017/8/22 Format: A4 判変型 Size: 210x210mm<br>
              Pages: 32 ページ (全ページフルカラー) Binding: ハードカバー<br>
              ISBN: 978-4-7562-4929-6 発売元: パイ インターナショナル
            </p>
          </div>
          <div class="col-12 d-flex justify-content-md-start justify-content-sm-center">
            <a href="https://pie.co.jp/book/i/4929/" target="_blank">
              <img src="/static/images/book/buy-pie.png" class="img-fluid" alt="PIE通販購入する">
            </a>
            <a href="https://www.amazon.co.jp/dp/4756249299" target="_blank">
              <img src="/static/images/book/buy-amazon.png" class="img-fluid" alt="Amazonで買う">
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="sample row">
          <div class="col-md-12 text-left">
            <b-link @click="showSample('isoide','0');">
              中身を見る
            </b-link>
          </div>
          <div v-for="(image, index) in images.isoide" class="col-4">
            <img :src="`${image.src}`" slot="img" class="img-fluid" @click="showSample('isoide',index);" />
          </div>
        </div>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/book/line.png" class="img-fluid" alt="黄色の破線">
      </div>
      <div class="col-sm-12 col-md-6">
        <img src="/static/images/book/member.png" class="img-fluid" alt="絵本作家のプロフィール画像">
      </div>
      <div class="col-sm-12 col-md-6 book-body">
        <div class="book-member">
          <p class="book-member-name">作　ヤスダ ユミコ</p>
          <p class="book-member-profile">
            アートディレクター。アイルクリエイティブ代表。
            企業や商品のブランディング、
            広告のグラフィックデザイン、立体デザインなどが
            主な仕事。秋川渓谷にあるアトリエの庭で、
            ハーブづくりに夢中になっている。
            海外のデザイン賞を多数受賞。
            <a href="http://www.ayrcreative.com" target="_blank">www.ayrcreative.com</a>
          </p>
        </div>
        <div class="book-member">
          <p class="book-member-name">作　むとう ゆういち (武藤 雄一)</p>
          <p class="book-member-profile">
            クリエイティブディレクター、コピーライター。
            武藤事務所代表。
            企業や商品のブランディングなどを手掛けている。
            広告賞などを多数受賞
          </p>
        </div>
        <div class="book-member">
          <p class="book-member-name">絵　まつもと まや (松本 摩耶)</p>
          <p class="book-member-profile">
            イラストレーター。アイルクリエイティブ所属。
            ヤスダとともに数々の企業の広告や
            商品パッケージなどのイラストを描いている。
            海外のデザイン賞を多数受賞。
            <a href="http://www.ayrcreative.com" target="_blank">www.ayrcreative.com</a>
          </p>
        </div>
      </div>
    </div>
    <b-modal id="sample" :hide-footer="true" :hide-header="true" size="xl">
      <b-button class="modal-close" data-dismiss="modal" aria-label="Close" @click="$bvModal.hide('sample')"><span aria-hidden="true">&times;</span></b-button>
      <template>
        <div class="book-carousel">
        <b-carousel
          id="carousel-fade"
          fade
          controls
          indicators
          width-height="600"
          img-height="600"
          :interval="6000"
        >
          <template v-for="image in modal_images">
            <b-carousel-slide :img-src="`${image.src}`" />
          </template>
        </b-carousel>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  title: 'えほん',
  name: 'book',
  components: {},
  data() {
    return {
      slide: 0,
      sliding: null,
      images: {
        hoshizora: [
          { src: "/static/images/book/hoshizora1.jpg" },
          { src: "/static/images/book/hoshizora2.jpg" },
          { src: "/static/images/book/hoshizora3.jpg" }
        ],
        okaimono: [
          { src: "/static/images/book/okaimono1.jpg" },
          { src: "/static/images/book/okaimono2.jpg" },
          { src: "/static/images/book/okaimono3.jpg" }
        ],
        mori: [
          { src: "/static/images/book/mori1.jpg" },
          { src: "/static/images/book/mori2.jpg" },
          { src: "/static/images/book/mori3.jpg" }
        ],
        isoide: [
          { src: "/static/images/book/isoide1.jpg" },
          { src: "/static/images/book/isoide2.jpg" },
          { src: "/static/images/book/isoide3.jpg" }
        ]
      },
      modal_images: []
    }
  },
  mounted: function() {
    this.$nextTick(function () {
      try {
        FONTPLUS.reload();
      } catch (error) {
        console.log(error.message);
      }
    })
  },
  methods: {
    showSample(title,index) {
      this.modal_images = this.images[title];
      this.$bvModal.show("sample");
    },
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Book.vue